import React, { useEffect, useState } from 'react';

import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import queryString from 'query-string';
import moment from 'moment';

import { isEmpty } from 'lodash';

import BobPage from '../../../components/BobPage';
import TableContainer from './TableContainer';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import BobTimeStampFilter from '../../../components/RuleExceptionsTable/BobTimestampFilter';
import KpiPanel from '../../../components/KpiPanel';
import HtmlTooltip from '../../../components/HtmlTooltip/HtmlTooltip';
import Navigation from '../Navigation/Navigation';
import { getTimeZoneAbbr } from '../../../helpers/timezones';

import {
    renderScoreData,
    renderFaultData
} from '../../../helpers/kpiHelpers';

import { getActiveTabName } from '../Navigation/NavigationHelper';

import * as DashboardActions from '../../../actions/dashboardActions';
import * as WeatherActions from '../../../actions/weatherActions';

import classes from './SitePage.module.css';

import { formatFootage } from '../../../utils/number-util';
import { formatUOMLabel } from '../../../utils/format-utils';

const SitePage = ({
    activeNavCompany,
    activeNavClient,
    activeNavSite,
    clearDashboardSiteData,
    companyApplications,
    companyInfo,
    dashboardEndTimeStamp,
    dashboardStartTimeStamp,
    equipmentFilters,
    energyKpis,
    fetchCurrentWeatherData,
    fetchDashboardData,
    fetchDashboardEquipmentData,
    fetchEnergyKpiData,
    fetchKpiData,
    history,
    setRuleScoreKpis,
    siteEquipmentKpis,
    siteEquipmentMeta,
    siteSystemKpis,
    siteSystemsMeta,
    siteWeatherData,
    systemFilters,
    targetNavSite,
    ...props
}) => {
    const [siteName, setSiteName] = useState();
    const [activeTab, setActiveTab] = useState('');
    const [weatherData, setWeatherData] = useState({});

    const queryValues = queryString.parse(history.location.search);

    useEffect(() => {
        setRuleScoreKpis([]);
        return () => {
            clearDashboardSiteData();
        };
    }, []);

    useEffect(() => {
        const { pathname } = history.location;
        const k2aCoreAppId = '1710345b-cf28-4a02-9bf4-df9209ff29cb';
        const bobId = 'ad356bf2-b9db-4bb5-922e-c3394b1a63e3';

        if ( !queryValues.appId) queryValues.appId = bobId; // bob
        if ( queryValues.appId === k2aCoreAppId) queryValues.appId = k2aCoreAppId; // k2aCore

        // set id's if not exist for BOB menu
        if ( queryValues.appId === bobId ) {
            if ( !queryValues.parentId) queryValues.parentId = 'c0c505f5-c7fc-4317-8cb6-f6e631142a77';
            if ( !queryValues.childId) queryValues.childId = 'bb5be75b-d466-48d5-99da-79cd66504f20';
        } else if ( queryValues.appId === k2aCoreAppId ) {
            if ( !queryValues.parentId) queryValues.parentId = '33ba6af0-1e7a-4fcf-b75b-f355a01a962b';
            if ( !queryValues.childId) queryValues.childId = '7035ee2f-b8ee-48ee-a9ac-ac522917dcdd';
        }
        
        if (!queryValues.company) queryValues.company = companyInfo.companyId;

        const queryValuesString = queryString.stringify(queryValues);

        history.push(`${pathname}?${queryValuesString}`);
    }, [companyInfo]);

    useEffect(() => {
        const { pathname } = history.location;
        const queryValues = queryString.parse(history.location.search);
        
        let key = queryValues.appId;
            
        if ( queryValues.parentId ) {
            key = queryValues.parentId;
        }

        if ( queryValues.childId ) {
            key = queryValues.childId;
        }

        let activetab = getActiveTabName(key);

        const queryValuesString = queryString.stringify(queryValues);

        history.push(`${pathname}?${queryValuesString}`);
        setActiveTab(activetab);
    }, [history.location.search]);

    useEffect(() => {
        const init = async () => {
            let promises = [fetchEnergyKpiData()];

            if (!isEmpty(siteEquipmentMeta) && activeTab !== 'Equipment') {
                promises.push(fetchDashboardEquipmentData(activeNavCompany.id, 'SiteEquipment', { clientId: activeNavClient.id, siteId: activeNavSite.id, sort: 'default^desc', page: 1, limit: 10, startDate: dashboardStartTimeStamp.format(), endDate: dashboardEndTimeStamp.format() }));
                promises.push(fetchKpiData(activeNavCompany.id, 'SiteEquipment', activeNavSite.id, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format()));
            }

            if (!isEmpty(siteSystemsMeta) && activeTab !== 'System') {
                promises.push(fetchDashboardData(activeNavCompany.id, 'SiteSystem', { clientId: activeNavClient.id, siteId: activeNavSite.id, page: 1, limit: 10, startDate: dashboardStartTimeStamp.format(), endDate: dashboardEndTimeStamp.format() }));
                promises.push(fetchKpiData(activeNavCompany.id, 'SiteSystem', activeNavSite.id, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format()));
            }

            await Promise.all(promises.map(p => p.catch(err => err)));
        };

        if (companyInfo.companyId && activeNavSite.id) init();
    }, [activeNavSite.id, dashboardEndTimeStamp, dashboardStartTimeStamp]);

    useEffect(() => {
        setSiteName(activeNavSite.name);
        if (activeNavSite.id && activeNavSite.address) { 
            const weatherOptions = {siteId: activeNavSite.id};
            fetchCurrentWeatherData(weatherOptions);
        }
        const init = async () => {
            await fetchKpiData(activeNavCompany.id, 'SiteEquipment', activeNavSite.id, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format());
        };

        if (activeTab && activeTab !== 'Equipment' && activeNavSite.id && isEmpty(siteEquipmentKpis)) init();
    }, [activeNavSite]);

    useEffect(() => {
        if (!isEmpty(siteWeatherData)) {
            const weather = siteWeatherData[0];
            weather.currentTemp = parseInt(weather.temp);
            try {
                weather.extendedData = JSON.parse(siteWeatherData[0].weather);
            }
            catch {
                weather.extendedData = {};
            }

            setWeatherData(weather);
        }
    }, [siteWeatherData]);

    const formatDate = date => {
        const zone = moment.tz.guess();
        return moment(date).format('YYYY-MM-DD h:mm A') + ' ' + getTimeZoneAbbr(moment(date), zone);
    };

    const buildEntityNameTooltip = props => {
        let fuelTypes;

        if (props.fuelTypes) {
            fuelTypes = props.fuelTypes.map(f => {
                return f.name;
            });
        }

        const salesContact = props.salesContact && props.salesContact.name ? props.salesContact.name : '';
        const facilitiesContact = props.facilitiesContact && props.facilitiesContact.name ? props.facilitiesContact.name : '';
        const energyContact = props.energyContact && props.energyContact.name ? props.energyContact.name : '';

        return (
            <div>
                <div className="entityTooltipTitle">Site Information</div>
                {props.address ? 
                    <>
                        <div className="entityTooltipHeader">Address</div>
                        <div className="entityTooltipDetail">{props.address.formattedAddress}</div>
                    </>
                    : 
                    null
                }
                <div className="entityTooltipHeader">Building Type</div>
                <div className="entityTooltipDetail">{props.buildingType.name}</div>
                <div className="entityTooltipHeader">Area</div>
                <div className="entityTooltipDetail">{formatFootage(props.squareFootage) + ' ' + formatUOMLabel(props.squareAreaUOM) }</div>
                <div className="entityTooltipHeader">Fuel Types</div>
                <div className="entityTooltipDetail">{fuelTypes ? fuelTypes.join(', ') : 'None' }</div>
                <div className="entityTooltipHeader">Contacts</div>
                <div>
                    <div style={{ display: 'inline-flex', padding: '0.2rem 0' }}>
                        <div className="entityTooltipDetail" style={{ float: 'left', width: '75px', paddingRight: '1rem' }}>
                            Sales:
                        </div>
                        <div className="entityTooltipDetail" style={{ float: 'right' }}>
                            { salesContact }
                        </div>
                    </div>
                    <br />
                    <div style={{ display: 'inline-flex', padding: '0.2rem 0' }}>
                        <div className="entityTooltipDetail" style={{ float: 'left', width: '75px', paddingRight: '1rem' }}>
                            Facilities:
                        </div>
                        <div className="entityTooltipDetail" style={{ float: 'right' }}>
                            {facilitiesContact}
                        </div>
                    </div>
                    <br />
                    <div style={{ display: 'inline-flex', padding: '0.2rem 0' }}>
                        <div className="entityTooltipDetail" style={{ float: 'left', width: '75px', paddingRight: '1rem' }}>
                            Energy:
                        </div>
                        <div className="entityTooltipDetail" style={{ float: 'right' }}>
                            { energyContact }
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const buildWeatherTooltip = weatherData => {
        return (
            <React.Fragment>
                <div className={classes.WeatherPanelWrapper}>
                    <div className={classes.WeatherMin}>
                        <div className={classes.WeatherSectionTitle}>Min</div>
                        <div className={classes.WeatherData}>{parseInt(weatherData.tempMin)}<span>{'\u00B0'}</span></div>
                    </div>
                    <div className={classes.WeatherMax}>
                        <div className={classes.WeatherSectionTitle}>Max</div>
                        <div className={classes.WeatherData}>{parseInt(weatherData.tempMax)}<span>{'\u00B0'}</span></div>
                    </div>
                    <div className={classes.WeatherPressure}>
                        <div className={classes.WeatherSectionTitle}>Pressure</div>
                        <div className={classes.WeatherData}>{weatherData.pressure}</div>
                    </div>
                    <div className={classes.WeatherHumidity}>
                        <div className={classes.WeatherSectionTitle}>Humidity</div>
                        <div className={classes.WeatherData}>{weatherData.humidity}%</div>
                    </div>
                    <div className={classes.WeatherWindDirection}>
                        <div className={classes.WeatherSectionTitle}>Direction</div>
                        <div className={classes.WeatherWindDataDirection}><i className={`wi wi-wind towards-${parseInt(weatherData.windDegree)}-deg`} /></div>
                    </div>
                    <div className={classes.WeatherWindSpeed}>
                        <div className={classes.WeatherSectionTitle}>Speed</div>
                        <div className={classes.WeatherData}>{weatherData.windSpeed}</div>
                    </div>
                    <div className={classes.WeatherTime}>As of: {formatDate(weatherData.timestamp)}</div>
                </div>
            </React.Fragment>
        );
    };

    return (
        <BobPage>
            <div className={classes.SitePage}>
                <div className={classes.BreadcrumbPanel}>
                    <Breadcrumb />
                </div>
                <div className={classes.HeaderPanel}>
                    <div className={classes.NavigationPanel}>
                        <Navigation />
                    </div>
                    <div className={classes.Date}>
                        {
                            activeTab === 'Contact' || activeTab === 'Health Monitor' ?
                                null
                                :
                                <BobTimeStampFilter
                                    className={classes.TimestampOverride}
                                    maxDate={moment().local()}
                                />
                        }
                    </div>
                </div>
                <div className={classes.TitlePanel}>
                    <div className={classes.Name}>
                        {siteName}
                        {!isEmpty(activeNavSite) ?
                            <HtmlTooltip
                                information={buildEntityNameTooltip(activeNavSite)}
                                placement={'right-start'}
                                body={
                                    <div className={'infoIcon'}><span className="material-icons-outlined md-16" style={{ cursor: 'default' }}>info</span></div>
                                }
                            />
                            : null
                        }
                        {
                            !isEmpty(weatherData) ?
                                <HtmlTooltip
                                    information={buildWeatherTooltip(weatherData) }
                                    placement={'right-start'}
                                    body={
                                        <div style={{paddingLeft: '10px'}}>
                                            <i className={`wi wi-owm-${ weatherData.extendedData[0].id }`} />
                                            <span style={{paddingLeft: '5px'}}>{weatherData.currentTemp}</span><span>{'\u00B0'}</span>
                                        </div>
                                    }
                                />
                                : null
                        }
                    </div>
                </div>
                {
                    process.env.dashboardKpiEnabled ?
                        <div className={classes.DataPanel}>
                            <KpiPanel
                                title="Score (% Change)"
                                data={activeTab === 'System' ? renderScoreData(siteSystemKpis, 'SiteSystem', false) : renderScoreData(siteEquipmentKpis, 'SiteEquipment', false)}
                                type="score"
                                className={classes.PercentChange}
                                information="Site Score Information"
                            />
                            <KpiPanel
                                title={activeTab === 'System' ? 'System Faults' : 'Equipment Faults'}
                                data={activeTab === 'System' ? renderFaultData(siteSystemKpis) : renderFaultData(siteEquipmentKpis)}
                                kpiType={'fault'}
                            />
                        </div>
                        :
                        null
                }
                <div className={classes.TablePanel}>
                    <TableContainer />
                </div>
            </div>
        </BobPage>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany:        state.bob.activeNavCompany,
        activeNavClient:         state.bob.activeNavClient,
        activeNavSite:           state.bob.activeNavSite,
        companyApplications:     state.bob.companyApplications,
        companyInfo:             state.companyInfo,
        dashboardEndTimeStamp:   state.dashboard.dashboardEndTimeStamp,
        dashboardStartTimeStamp: state.dashboard.dashboardStartTimeStamp,
        energyKpis:              state.dashboard.energyKpis,
        equipmentFilters:        state.dashboard.equipmentFilters,
        siteEquipmentKpis:       state.dashboard.siteEquipmentKpis,
        siteEquipmentMeta:       state.dashboard.siteEquipmentMeta,
        siteSystemKpis:          state.dashboard.siteSystemKpis,
        siteTabIndex:            state.dashboard.siteTabIndex,
        siteSystemsMeta:         state.dashboard.siteSystemsMeta,
        siteWeatherData:         state.weather.currentSiteWeatherData,
        systemFilters:           state.dashboard.systemFilters,
        targetNavSite:           state.bob.targetNavSite
    };
};

const mapDispatchToProps = {
    ...DashboardActions,
    ...WeatherActions
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SitePage));
